import { useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { useToast } from '@sketch/toasts'

export const useIntegrationErrorHandler = () => {
  const location = useLocation()
  const history = useHistory()
  const { showToast } = useToast()

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search)
    const errorParam = urlParams.get('error')

    if (errorParam === 'integration_failed') {
      showToast(
        'There was an issue setting up your integration, please try again',
        'negative'
      )

      // Clean up the URL by removing the error parameter
      urlParams.delete('error')

      history.replace(location.pathname)
    }
  }, [location.search, location.pathname, history, showToast])
}
